<template>
    <div style="padding-left: 35px; padding-right: 35px">
        <v-row style="background-color: #fff; padding: 30px;">
            <v-col cols="2">
                <v-icon large icon="mdi-arrow-left" @click="$router.push('/config')"
                    style="font-size: 46px">mdi-arrow-left</v-icon>
            </v-col>
            <v-col cols="8" style="text-align: center!important; margin-bottom: 20px;">
                <v-typography style="text-transform: uppercase; letter-spacing: 5px;">
                    Machines
                </v-typography>
                
            </v-col>
            
            <v-divider></v-divider>
            <v-btn @click="openAddCustomMachineModal"> Add Machine</v-btn>
            <v-text-field v-model="search" label="Search" prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line>
            </v-text-field>
            
            
            <v-data-table :items="machines" :search="search" :loading="isLoadingMachines" :headers="headers" :sort-by="[{ key: 'id', order: 'asc' }]">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.id }}</td>
                        <td>{{ item.name }}</td>
                        <!-- <td>{{ item.unit }}</td> -->
                        <td>{{ item.line || "-" }}</td>
                        <td>
                            <v-row>
                                <v-col cols="auto" v-for="mcf in item.global_machine_custom_fields" :key="mcf">
                                    <v-chip style="height: fit-content!important;" color="primary">
                                        <v-list-item :title="mcf.name" :subtitle="customSubtitle(mcf.data_type)">

                                        </v-list-item>
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </td>

                        <td style="text-align: end">
                            <v-btn color="primary" variant="outlined" class="mt-4 mb-4 me-2">
                                <v-icon start>mdi-plus</v-icon>
                                Add custom fields
                                <v-dialog activator="parent" persistent>
                                    <template v-slot:default="{ isActive }">
                                        <v-card class="mx-auto" style="" min-width="900">
                                            <v-toolbar>
                                                <v-btn icon="mdi-close" @click="isActive.value = false"></v-btn>
                                                <v-toolbar-title>Custom field
                                                    for
                                                    machine {{ item.id }}
                                                </v-toolbar-title>

                                            </v-toolbar>
                                            <v-card-text>
                                                <v-text-field variant="outlined" label="Field name"
                                                    v-model="customFieldName"></v-text-field>

                                                <v-select variant="outlined" label="Field type" :items="fieldTypes"
                                                    item-title="name" item-value="value" v-model="type"
                                                    @change="zeroChoices()"></v-select>
                                                <v-checkbox label="Active custom field"
                                                    v-model="activeCustomField"></v-checkbox>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn class="ms-2" @click="cancelStepper(isActive)"
                                                    prepend-icon="mdi-close" color="#1e2ec6"
                                                    variant="outlined">CANCEL</v-btn>
                                                <v-btn
                                                    @click="createCustomField(customFieldName, type, activeCustomField, item.id, isActive)"
                                                    prepend-icon="mdi-content-save" color="#1e2ec6" variant="tonal">Save
                                                    custom field</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </template>
                                </v-dialog>
                            </v-btn>
                            <v-btn color="primary" variant="outlined" class="mt-4 mb-4">
                                <v-icon start>mdi-plus</v-icon>
                                Assign line
                                <v-dialog activator="parent" persistent>
                                    <template v-slot:default="{ isActive }">
                                        <v-card class="mx-auto" style="" min-width="900">
                                            <v-toolbar>
                                                <v-btn icon="mdi-close" @click="isActive.value = false"></v-btn>
                                                <v-toolbar-title>Assign line
                                                    for
                                                    machine {{ item.id }}
                                                </v-toolbar-title>

                                            </v-toolbar>
                                            <v-card-text>

                                                <v-select variant="outlined" label="Select line" :items="allLines"
                                                    item-title="name" item-value="id"
                                                    v-model="item.line"></v-select>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn class="ms-2" @click="cancelStepper(isActive)"
                                                    prepend-icon="mdi-close" color="#1e2ec6"
                                                    variant="outlined">CANCEL</v-btn>
                                                <v-btn @click="assignLineToMachine(item.line, item.id, isActive)"
                                                    prepend-icon="mdi-content-save" color="#1e2ec6" variant="tonal">Save</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </template>
                                </v-dialog>
                            </v-btn>
                        </td>

                    </tr>
                </template>
            </v-data-table>
        </v-row>
        <v-dialog v-model="newCustomMachineModal" max-width="700px">
            <v-card>
                <v-card-title>Add custom machine</v-card-title>
                <v-card-text>
                    <v-text-field v-model="newCustomMachineName" label="Machine name"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="addCustomMachine">Save</v-btn>
                    <v-btn @click="closeAddCustomMachineModal">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            headers: [
                { title: 'ID', value: 'id', sortable: true },
                { title: 'Name', value: 'name', sortable: true },
                // { title: 'Unit', value: 'unit', sortable: true },
                { title: 'Line', value: 'line', sortable: true },
                { title: 'Custom fields' },
                { title: '' },

            ],
            selected: [],
            oneOption: "",
            optionDescription: "",
            choices: [],
            type: '',
            choice: [],
            stepItems: ['Step 1', 'Step 2'],
            fieldTypes: [{ name: 'String', value: 'string' }, { name: 'Number', value: 'int' }, { name: 'Decimal', value: 'float' }, { name: 'True/False', value: 'bool' }],
            validationGroup: [{ name: 'Greater than or equal', value: 'GTE' }, { name: 'Lesser than or equal', value: 'LTE' }, { name: 'Equal', value: 'EQ' }, { name: 'Not equal', value: 'NEQ' }],
            step: 1,
            machines: [],
            search: '',
            isLoadingMachines: false,
            activeCustomField: true,
            customFieldName: "",
            allLines: [],
            selectedLineId: '',
            newCustomMachineName: '',
            newCustomMachineModal: false,

        };
    },
    async mounted() {
        await this.getMachineList();
        this.getAllLines();
    },
    methods: {
        openAddCustomMachineModal(){
            this.newCustomMachineModal = true;
        },
        closeAddCustomMachineModal(){
            this.newCustomMachineModal = false;
        },
        async addCustomMachine(){
            await axios.post('/apiv1/machinenofbs/machinenofbs-add', {name: this.newCustomMachineName}).then(res => {
                console.log(res);
                this.getMachineList();
                this.newCustomMachineModal = false;
            }).catch(err => {
                console.log(err);
            })
        },

        /**
         * Assigns a line to a machine and updates the machine list.
         *
         * @param {number} selectedLineId - The ID of the selected line to be assigned.
         * @param {number} machineId - The ID of the machine to which the line will be assigned.
         * @param {Object} isActive - A reactive reference indicating if the assignment is active.
         * @returns {Promise<void>} - A promise that resolves when the line is assigned and the machine list is updated.
         *
         * @example
         * await assignLineToMachine(1, 2, isActive);
         *
         * This function sends a POST request to the server to assign the specified line to the machine.
         * On success, it logs the response, sets `isActive.value` to false, clears `selectedLineId`, and refreshes the machine list.
         * On failure, it logs the error.
         */
        async assignLineToMachine(selectedLineId, machineId, isActive) {
            console.log(selectedLineId, machineId, isActive);
            await axios.post(`/apiv1/machines/${machineId}/mc-set-line`, {line: selectedLineId} ).then(res =>{
                console.log(res);
                isActive.value = false;  
                this.selectedLineId = ""
                this.getMachineList();
            }).catch(err =>{
                console.log(err);
                
            })
        },
        /**
         * Fetches all lines from the API.
         * 
         * This method sends a GET request to the '/apiv1/alines' endpoint using Axios.
         * On a successful response, it logs the response to the console and assigns the 
         * response data to the `allLines` property.
         * If an error occurs during the request, it logs the error to the console.
         */
        getAllLines() {
            axios.get('/apiv1/alines').then(res => {
                console.log(res);
                this.allLines = res.data
            }).catch(err => {
                console.log(err);
            })
        },
        /**
         * Generates a custom subtitle based on the provided type.
         *
         * @param {string} type - The type to generate the subtitle for. 
         *                        Possible values are 'string', 'int', 'float', and 'bool'.
         * @returns {string} - Returns "Text" for 'string', "Number" for 'int', "Decimal" for 'float', 
         *                     "True/False" for 'bool', and 'undefined' for any other type.
         */
        customSubtitle(type) {
            return type == 'string' ? "Text" : type == 'int' ? "Number" : type == 'float' ? "Decimal" : type == "bool" ? "True/False" : 'undefined'
        },
        /**
         * Creates a custom field for a machine by sending a POST request to the server.
         *
         * @param {string} name - The name of the custom field.
         * @param {string} type - The data type of the custom field.
         * @param {boolean} active - Indicates if the custom field is active.
         * @param {string} machine - The machine to which the custom field belongs.
         * @param {Object} isActive - A reactive reference to control the active state of the custom field.
         * @returns {Promise<void>} - A promise that resolves when the custom field is created.
         */
        async createCustomField(name, type, active, machine, isActive) {
            await axios.post('/apiv1/mcf/mcf-add', {
                name: name,
                data_type: type,
                global_type: true,
                active: active,
                machine: machine
            }).then(res => {
                console.log(res);
                if (res.status == 200) {
                    console.log(isActive);
                    this.getMachineList();
                    isActive.value = false;
                }

            }).catch(err => {
                console.log(err);

            });

        },
        cancelStepper(isActive) {
            isActive.value = false;
            this.choices = [];
            this.step = 1;
            this.oneOption = "";
            this.optionDescription = "";
            this.type = '';
            this.choice = [];
            this.selectedLineId = "";
        },
        addChoice(index, choice, description) {
            this.choices.push({
                value: choice,
                description: description
            });
            this.oneOption = "";
            this.optionDescription = "";
        },
        zeroChoices() { this.choices = [] },
        removeChoice(index) {
            this.choices.splice(index, 1)
            console.log(index);
        },
        validationType(type) {
            console.log(type);
            return type === 'float' ? 'number' : 'text';
        },
        /**
         * Fetches the list of machines from the API.
         * 
         * This method sets the `isLoadingMachines` flag to true before making an asynchronous
         * GET request to the '/apiv1/machines/list' endpoint using Axios. Upon a successful response,
         * it logs the response to the console and assigns the response data to the `machines` property.
         * If an error occurs during the request, it logs the error to the console and sets the 
         * `isLoadingMachines` flag to false. Finally, it sets the `isLoadingMachines` flag to false 
         * after the request is completed.
         * 
         * @returns {Promise<void>} A promise that resolves when the machine list has been fetched.
         */
        async getMachineList() {
            this.isLoadingMachines = true
            await axios.get('/apiv1/machines/list').then(res => {
                console.log(res);
                this.machines = res.data;

            }).catch(err => {
                console.log(err);
                this.isLoadingMachines = false;
            });
            this.isLoadingMachines = false;
        }
    },
    components: {
    }
};
</script>
<style scoped></style>
